import React from 'react';

import { useKioskManager } from '../../../hooks/useKioskManager';
import styles from './title.module.scss';

type TitleProps = {
  children: string;
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
};

const Title: React.FC<TitleProps> = ({ children, as = 'h1' }) => {
  const Tag = as;
  const { kiosk, kioskMode } = useKioskManager();
  return (
    <Tag className={styles.title}>
      <span className={`${kiosk && kioskMode && styles[kiosk.model]}`}>
        {children}
      </span>
    </Tag>
  );
};

export default Title;
